
import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ResourcesHelmet from '../components/resources/ResourcesHelmet';
import ResourcesTabs from '../components/resources/ResourcesTabs';

const Education = () => {
  const [activeTab, setActiveTab] = useState<'videos' | 'tweets'>('videos');

  return (
    <div className="min-h-screen flex flex-col">
      <ResourcesHelmet />
      <Navbar />
      
      <main className="flex-grow pt-4 md:pt-8">
        <div className="container mx-auto px-4 mb-8 md:mb-12">
          <h1 className="text-2xl md:text-3xl font-bold mb-2 md:mb-4">Resources</h1>
          <p className="text-base md:text-lg text-muted-foreground mb-6 md:mb-8">
            Learn more about medications, treatments, and health conditions through our curated educational content.
          </p>
          
          <ResourcesTabs activeTab={activeTab} setActiveTab={setActiveTab} />
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default Education;
